import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CONSTS, CVIS_OPTIONS } from './cvis-smart-enabled-setting.constants';

@Component({
  selector: 'app-cvis-smart-enabled-setting',
  templateUrl: './cvis-smart-enabled-setting.component.html',
  styleUrl: './cvis-smart-enabled-setting.component.scss',
  standalone: false,
})
export class CvisSmartEnabledSettingComponent {
  @Input({ required: true }) form!: FormGroup;

  readonly CONSTANTS = CONSTS;
  readonly OPTIONS = CVIS_OPTIONS;
}
